module.exports = __webpack_public_path__ + "img/point-icon.618c526b.svg";